import { Finish } from "./components/finish";
import { Base } from "./finishes.base";

export const Finishes = Object.assign(Base, {
    Finish
});
